function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#F4F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10 10h12v12.5H10z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 14v-4h4v4h3l-5 5-5-5h3zM22 22.5H10v-2h12v2z",
  fill: "#6F8190"
});

var SvgIconDownloadNormal = function SvgIconDownloadNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxjaXJjbGUgY3g9IjE2IiBjeT0iMTYiIHI9IjE2IiBmaWxsPSIjRjRGN0Y5Ii8+CjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMi41IiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCAxMCkiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxNFYxMEgxOFYxNEgyMUwxNiAxOUwxMSAxNEgxNFYxNFoiIGZpbGw9IiM2RjgxOTAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMiAyMi41SDEwVjIwLjVIMjJWMjIuNVoiIGZpbGw9IiM2RjgxOTAiLz4KPC9zdmc+Cg==";
export { SvgIconDownloadNormal as ReactComponent };